import React, { useEffect, useState } from 'react'
import { useForgotPasswordMutation, useResetPasswordMutation } from '../../app/config/redux/slices/api/userApiSlice';
import AlertMessage from './AlertMessage';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
    const [otp, setOtp] = useState(false);
    const [resendTimer, setResendTimer] = useState(0);
    const [mobile, setMobile] = useState("");
    const [otpCode, setOtpCode] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState(""); 
    const [alert, setAlert] = useState(null);
    const [errors, setErrors] = useState({});

    const navigate = useNavigate();

  const [forgotPassword] = useForgotPasswordMutation();
  const [resetPassword] = useResetPasswordMutation();

    useEffect(() => {
        let timer;
        if (resendTimer > 0) {
            timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
        }
        return () => clearTimeout(timer);
    }, [resendTimer]);

  const forgotSubmitHandler = async (e) => {
    e.preventDefault();
    try {
      const res = await forgotPassword({
        mobile: mobile,       
        app_detect: "78945"   
      }).unwrap();

        setAlert({ type: 'success', message: res.message });

        setTimeout(() => {
            setAlert(null); // Auto close after 3s
        }, 3000);
        setOtp(true); 
        setResendTimer(120);  
    } catch (error) {
        setAlert({ type: 'danger', message: error?.data?.message || error.error });

        setTimeout(() => {
        setAlert(null); // Auto close after 3s
        }, 3000);
        setErrors(error?.data?.errors || {});
    }
  };

    const resetSubmitHandler = async (e) => {
    e.preventDefault();
    try {
        const res = await resetPassword({
            mobile: mobile,
            otp: otpCode,
            password: password,
            password_confirmation: passwordConfirmation,
        }).unwrap();
            console.log(res);
            setAlert({ type: 'success', message: res.status });

            setTimeout(() => {
                setAlert(null); // Auto close after 3s
            }, 3000); 
            navigate("/account")

    } catch (error) {
        setAlert({ type: 'danger', message: error?.data?.message || error.error });

        setTimeout(() => {
        setAlert(null); // Auto close after 3s
        }, 3000);
        setErrors(error?.data?.errors || {});
    }
  };

  return (
    <section className="account py-80">
      {alert && (
        <AlertMessage
          message={alert.message}
          type={alert.type}
          onClose={() => setAlert(null)}
        />
      )}

      <div className="container container-lg">
        <div className="row gy-4">
          <div className="col-xl">
            <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 h-100">
              {!otp ? (
                <>
                  <h6 className="text-xl mb-32">Forgot Password</h6>
                  <form onSubmit={forgotSubmitHandler}>
                    <div className="mb-24">
                      <label
                        htmlFor="mobile"
                        className="text-neutral-900 text-lg mb-8 fw-medium"
                      >
                        Mobile Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`common-input ${errors.mobile ? "is-invalid" : ""}`}
                        id="mobile"
                        placeholder="Enter your mobile number"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                      />
                      {errors.mobile && (
                        <div className="invalid-feedback">{errors.mobile[0]}</div>
                      )}
                    </div>

                    <div className="mt-48">
                      <button
                        type="submit"
                        className="btn btn-main py-18 px-40"
                      >
                        Send OTP
                      </button>
                    </div>
                  </form>
                </>
              ) : (
                <>
                  <h6 className="text-xl mb-32">Reset Password</h6>
                  <form onSubmit={resetSubmitHandler}>
                    <div className="mb-24">
                      <label
                        htmlFor="otp"
                        className="text-neutral-900 text-lg mb-8 fw-medium"
                      >
                        OTP <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`common-input ${errors.otp ? "is-invalid" : ""}`}
                        id="otp"
                        placeholder="Enter OTP"
                        value={otpCode}
                        onChange={(e) => setOtpCode(e.target.value)}
                      />
                      {errors.otp && (
                        <div className="invalid-feedback">{errors.otp[0]}</div>
                      )}
                    </div>

                    <div className="mb-24">
                      <label
                        htmlFor="password"
                        className="text-neutral-900 text-lg mb-8 fw-medium"
                      >
                        New Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        className={`common-input ${errors.password ? "is-invalid" : ""}`}
                        id="password"
                        placeholder="Enter new password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      {errors.password && (
                        <div className="invalid-feedback">{errors.password[0]}</div>
                      )}
                    </div>

                    <div className="mb-24">
                      <label
                        htmlFor="password_confirmation"
                        className="text-neutral-900 text-lg mb-8 fw-medium"
                      >
                        Confirm Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        className={`common-input ${errors.password_confirmation ? "is-invalid" : ""}`}
                        id="password_confirmation"
                        placeholder="Confirm new password"
                        value={passwordConfirmation}
                        onChange={(e) => setPasswordConfirmation(e.target.value)}
                      />
                      {errors.password_confirmation && (
                        <div className="invalid-feedback">
                          {errors.password_confirmation[0]}
                        </div>
                      )}
                    </div>

                    <div className="mt-48">
                      <button
                        type="submit"
                        className="btn btn-main py-18 px-40"
                      >
                        Reset Password
                      </button>

                        <div className="mt-24">
                        {resendTimer > 0 ? (
                            <span className="text-neutral-500 text-sm fw-medium">
                            Resend OTP in {resendTimer}s
                            </span>
                        ) : (
                            <span
                            className="text-danger-600 text-sm fw-semibold hover-text-decoration-underline cursor-pointer"
                            onClick={() => setOtp(false)} // call API again
                            >
                            Resend OTP
                            </span>
                        )}
                        </div>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;